export default "__VITE_ASSET__qNwnUfT___"